<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("wms.menu.product") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <base-button
                        size="md"
                        type="neutral"
                        @click="handleCreate()"
                        >{{ $t("new") }}</base-button
                    >

                    <!-- <base-button size="md" type="neutral" v-if="isCorporateAdmin || isDtacAdmin">{{
            $t("upload_file")
          }}</base-button> -->
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
						<div class="row">
                        <div class="col-lg-3">
                            <base-input
                                v-model="searchQuery"
                                prepend-icon="fas fa-search"
                                :placeholder="$t('search')"
                            >
                            </base-input>
                        </div>

						 <div class="col-md-2">
                                <base-input>
                                    <el-select v-model="productStatus" :placeholder="$t('status')" >
                                        <el-option v-for="option in StatusTable" :key="option.id" :label="option.name" :value="option.id" > </el-option>
                                    </el-select>
                                </base-input>
                            </div>

						<div class="col-lg-3">
							<base-button
								size="md"
								type="primary"
								@click="handleExport()"
								>Export</base-button
							>
						</div>
						</div>
                    </template>
                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                        >

							<el-table-column >
									<div slot-scope="{  row }" class="d-flex">
										<img :src="GetProductUrl(row.images)" height="100px" v-if="row.images.includes('.png') || row.images.includes('.jpg') || row.images.includes('jpeg')"/>
									</div>
							</el-table-column>

                            <el-table-column :label="$t('name')" >
								<div slot-scope="{  row }" >
									{{ row.name}}
								</div>
                            </el-table-column>

                            <el-table-column :label="$t('code')" >
								<div slot-scope="{  row }" >
									{{ row.code}}
								</div>
                            </el-table-column>

                            <el-table-column :label="$t('price')" >
								<div slot-scope="{  row }" >
									{{ row.price}}
								</div>
                            </el-table-column>

							<el-table-column :label="$t('shipping_cost')" >
								<div slot-scope="{  row }" >
									{{ row.shipping_cost}}
								</div>
                            </el-table-column>

                            <el-table-column :label="$t('tag')" >
								<div slot-scope="{  row }" >
									{{ row.tag}}
								</div>
                            </el-table-column>
							<el-table-column :label="$t('status')" >
								<div slot-scope="{  row }" >
									<template v-if="row.status == 1">ใช้งาน</template>
									<template v-if="row.status == 2">ไม่ใช้งาน</template>
								</div>
                            </el-table-column>

                            <el-table-column
                                align="right"
                                :label="$t('actions')"
                            >
                                <div
                                    slot-scope="{ $index, row }"
                                    class="d-flex"
                                >
                                    <base-button
                                        @click.native="handleEdit($index, row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button>
                                    <base-button
                                        @click.native="
                                            handleDelete($index, row)
                                        "
                                        class="remove btn-link"
                                        type="danger"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-trash"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="queriedData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <modal :show.sync="showAddModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                <base-input :label="$t('name')" v-model="params.name"> </base-input>

                <base-input :label="$t('description')" v-model="params.detail">
                </base-input>


                <input type="hidden" class="new-event--start" />
                <input type="hidden" class="new-event--end" />
            </form>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleUpdate()"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showAddModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import { read, utils, writeFile } from 'xlsx'

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableDataOrg: "Product/getData",
            getCurrentPage: "Product/getCurrentPage"
        }),
        tableData: function() {
            if (this.productStatus != 0) {
              return this.tableDataOrg.filter((m)=>{
                return m.status == this.productStatus
              });
            }

            return this.tableDataOrg;
        },
		searchParams: function(){
			return {
				platform_id:1
			}
		}
       
    },
    data() {
        return {
            propsToSearch: ["name", "tag"],
            selectedRows: [],
            showAddModal: false,
            params: {
                id: 0,
                name: "",
                detail: "",
                price: "",
                cod: "",
                code: "",
				atrributes:"",
				tag:"",
				status:1,
				product_sku:"",
            },
			productStatus:1,
			StatusTable : [
				{id:0,name:"ทั้งหมด"},
				{id:1,name:"ใช้งาน"},
				{id:2,name:"ไม่ใช้งาน"},
			]
        };
    },
    mounted() {
        this.listData(this.searchParams);
		this.pagination.currentPage = this.getCurrentPage
    },
    methods: {
        ...mapActions({
            createData: "Product/createData",
            updateData: "Product/updateData",
            deleteData: "Product/deleteData",
            listData: "Product/listData",
            setCurrentPage: "Product/setCurrentPage"
        }),
		handleExport(){
			let i = 1
			let dataExport = this.tableData.map((v) => {
				return {
				NO: i++,
				Name: v.name,
				Code: v.code,
				Price: v.price,
				Tag: v.tag,
				Status: v.status == 1 ? "ใช้งาน" : "ไม่ใช้งาน",
				}

			})
			const dataWS = utils.json_to_sheet(dataExport)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			writeFile(wb,'export_products_promotion.xlsx')

		},
        handleCreate() {
			this.$router.push({ name: "product_form" });
        },
        handleEdit(index, row) {
            this.showAddModal = true;
			this.setCurrentPage(this.pagination.currentPage)
			this.$router.push({ name: "product_form" ,params:{params:row}});
      
        },
        handleUpdate() {
            this.showAddModal = false;
            // Create

            if (this.params.id == 0) {
                this.createData(this.params)
                    .then(resp => {
                        this.listData(this.searchParams);
                        swal.fire({
                            title: this.$t("create_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            } else {
                // Update
                this.updateData({id:this.params.id,payload:this.params})
                    .then(resp => {
                        this.listData(this.searchParams);
                        swal.fire({
                            title: this.$t("edit_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            }
        },
        handleDelete(index, row) {

			this.setCurrentPage(this.pagination.currentPage)
            swal.fire({
                title: this.$t("delete_confirm"),
                text: this.$t("delete_confirm_question") + row.name,
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteData(row.id)
                        .then(resp => {
                            this.listData(this.searchParams);
							this.pagination.currentPage = this.getCurrentPage
                            swal.fire({
                                title: this.$t("delete_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
        },
        filesChange(files) {
            if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกไฟล์รูปภาพ",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
            } else {
            }
            this.params.files = files[0];
        },
		GetProductUrl(filename){
			return process.env.VUE_APP_API_BASE_URL + "/files/products/" + filename
		}
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
